<script lang="ts" setup>
import { useDialogStore } from '../../../lib/dialog/store'
// Props
// end Props

// Emits
// end Emits

// Refs
// end Refs

// Computed
// end Computed

// Functions
// end Functions

// Async Api functions
// end Async Api functions

// Lifecycle Hooks / Init
// end Lifecycle Hooks / Init

const dialogStore = useDialogStore()
</script>

<template>
  <Teleport to="body">
    <component :is="dialog.component" v-for="dialog in dialogStore.items" :key="dialog.id" v-bind="dialog.attributes" />
  </Teleport>
</template>

<style lang="scss" scoped>
/* stylelint-disable-next-line block-no-empty */
</style>
